import {Base, model, endpoint, belongsTo, hasMany} from '@scoutgg/ftw/source/lib/model'

@model('TeamSource')
@endpoint('team-sources', {root: '/api'})
@belongsTo('seasonSource')
@belongsTo('team')
@hasMany('teamSources')
export class TeamSource extends Base {
}
